import { h, type Component, type VNodeChild } from 'vue';
import type { FormatterFactory } from '../types';
import { compilePath } from '../gridCell';

export interface ClicksinkOptions {
  displayMember?: string;
}

export const clicksink: FormatterFactory = (options: ClicksinkOptions = {}) => {
  const readDisplay = options.displayMember
    ? compilePath(options.displayMember)
    : null;

  const text = (value: any, context: any): string => {
    const raw = readDisplay ? readDisplay(context) : value;
    return raw == null ? '' : String(raw);
  };

  const renderer = (
    props: { value: any; context: any },
    { slots }: { slots: Record<string, any> },
  ): VNodeChild => {
    const label = readDisplay
      ? text(props.value, props.context)
      : slots.default
        ? undefined
        : text(props.value, props.context);

    return h(
      'a',
      { href: '#', class: 'itp-data-grid__command', tabindex: 0 },
      label !== undefined ? label : slots.default?.(),
    );
  };

  renderer.props = ['value', 'context'];

  return {
    component: renderer as Component,
    props: (_value, context) => ({ context }),
    command: true,
    toText: (value, context) => text(value, context),
  };
};
